import defaultUser from 'Images/defaultUser.svg';
import { User } from 'Models';

// eslint-disable-next-line import/prefer-default-export
export const useGetProfileImage = (user: User) =>
  user.profilePictureUrl || defaultUser;
